module.exports = __webpack_public_path__ + "img/bankshahr.95b8849.png";